import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { iconButton, mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

const iconSize = 32;

export const iconbar = css`
  display: flex;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-right: -${pxToRem(20)};
    `,
  )}
`;

export const focusedLink = css`
  color: ${palette.purple70};
  --iconColor: ${palette.purple70};
`;

export const link = css`
  position: relative;
  display: flex;
  flex-direction: column;
  ${theme.responsiveText.BODY.XS}
  text-decoration: none;
  color: ${palette.purpleBase};
  --iconColor: ${palette.purpleBase};

  &:hover,
  &:active,
  &:focus {
    ${focusedLink}
  }
`;

export const icon = css`
  width: ${pxToRem(iconSize)};
  height: ${pxToRem(iconSize)};
`;

export const basketCount = css`
  position: absolute;
  top: ${pxToRem(-4)};
  right: ${pxToRem(-16)};
  width: ${pxToRem(42)};
  text-align: center;
  pointer-events: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      right: ${pxToRem(spacing.xs)};
    `,
  )}

  span {
    display: inline-block;
    border-radius: ${pxToRem(10)};
    padding: 0 ${pxToRem(6)};
    min-width: ${pxToRem(16)};
    background-color: var(--functional-red-base);
    color: var(--neutral-white-base);
    ${theme.responsiveText.BODY.SM};
  }
`;

export const iconBtn = css`
  ${iconButton}
  display: block;
`;
